const translateLocalTimezone = (utcObj) => {
  if (!utcObj) return utcObj
  const strDateTime = utcObj.split('-')
  const numDateTime = strDateTime.map((e) => Number(e))
  return new Date(numDateTime[0], (numDateTime[1] - 1), numDateTime[2])
}

export default translateLocalTimezone
